export default "__VITE_ASSET__e91f15d8__"